import Swal from 'sweetalert2';
import { api } from '../../domainConfig';
import axiosInstance from '../axiosInstance';

const domainMovement = api.movementService;
const domainUsers = api.userManagementDomain

/* eslint no-shadow: ["error", { "allow": ["state"] }] */

const showToast = (icon, title) => {
  Swal.fire({
    icon,
    title,
    toast: true,
    position: 'top-end',
    showConfirmButton: false,
    timer: 3500,
  });
};

const state = {
  isProductInTransit: {
    defaultValue: false, value: false, method: 'get', endpoint: 'is_product_added_into_transit', domain: domainMovement,
  },
  isOrderInTransit: {
    defaultValue: false, value: false, method: 'get', endpoint: 'is_orderItem_added_into_pending', domain: domainMovement,
  },
  lineItemsPagination: {
    defaultValue: [], value: [], method: 'get', endpoint: 'line_items_pagination', domain: domainMovement,
  },
  productsInStockPagination: {
    defaultValue: [], value: [], method: 'get', endpoint: 'productinstock_items_pagination', domain: domainMovement,
  },
  lineItemsPaginationInternal: {
    defaultValue: [], value: [], method: 'get', endpoint: 'line_items_pagination', domain: domainMovement,
  },
  productsInStockPaginationInternal: {
    defaultValue: [], value: [], method: 'get', endpoint: 'productinstock_items_pagination', domain: domainMovement,
  },
  addWindowInPending: {
    defaultValue: null, value: null, method: 'post', endpoint: 'add_windowItem_pending', domain: domainMovement, successMessage: 'Window added successfully',
  },
  addProductsInStockPending: {
    defaultValue: null, value: null, method: 'post', endpoint: 'add_productInStock_pending', domain: domainMovement, successMessage: 'Article added successfully',
  },
  createOrderMovement: {
    defaultValue: null, value: null, method: 'post', endpoint: 'create_store_to_store_order_movement', domain: domainMovement, successMessage: 'Order movement created successfully',
  },
  createOrderMovementInternal: {
    defaultValue: null, value: null, method: 'post', endpoint: 'create_location_to_location_order_movement', domain: domainMovement, successMessage: 'Order movement internally created successfully',
  },
  editProductInStockMovement: {
    defaultValue: null, value: null, method: 'put', endpoint: 'edit_productInStockMovement', domain: domainMovement, successMessage: 'Edited product in stock movement successfully',
  },
  deleteProductsInStockMovementId: {
    defaultValue: null, value: null, method: 'delete', endpoint: 'delete_productInStockMovement_ByProductInStockMovementId', domain: domainMovement, successMessage: 'Deleted product in stock movement successfully',
  },
  deleteLineItemMovementId: {
    defaultValue: null, value: null, method: 'delete', endpoint: 'delete_lineItemMovement_ById', domain: domainMovement, successMessage: 'Deleted line item movement successfully',
  },
  usersByMultipleRoles: {
    defaultValue: [], value: null, method: 'post', endpoint: 'users_by_multiple_roles', domain: domainUsers,
  },
  storeToStoreDeliverer: {
    defaultValue: [], value: [], method: 'get', endpoint: 'store_to_store_movements_pagination', domain: domainMovement,
  },
  storeToStoreReceiver: {
    defaultValue: [], value: [], method: 'get', endpoint: 'store_to_store_movements_pagination', domain: domainMovement,
  },
  movementOrderNumberLike: {
    defaultValue: [], value: [], method: 'get', endpoint: 'movement_order_number_like', domain: domainMovement,
  },
  orderMovementDetails: {
    defaultValue: {}, value: {}, method: 'get', endpoint: 'order_movement_details_by_Id', domain: domainMovement,
  },
  orderMovementDetailsPDF: {
    defaultValue: {}, value: {}, method: 'get', endpoint: 'order_movement_details_by_Id', domain: domainMovement,
  },
  updateReceiverStoreIdByOrderMovement: {
    defaultValue: null, value: null, method: 'put', endpoint: 'update_receiverStoreId_by_orderMovementId', domain: domainMovement, successMessage: 'Updated store in order movement successfully',
  },
  updateDeliveryDateByOrderMovement: {
    defaultValue: null, value: null, method: 'put', endpoint: 'update_deliverDate_by_orderMovementId', domain: domainMovement, successMessage: 'Updated deliver date in order movement successfully',
  },
  updateStateByOrderMovement: {
    defaultValue: null, value: null, method: 'put', endpoint: 'update_state_by_orderMovementId', domain: domainMovement, successMessage: 'Updated state in order movement successfully',
  },
  updateUserIdByOrderMovement: {
    defaultValue: null, value: null, method: 'put', endpoint: 'update_userID_by_orderMovementId', domain: domainMovement, successMessage: 'Updated user in order movement successfully',
  },
  updateLocation: {
    defaultValue: null, value: null, method: 'put', endpoint: 'update_locationId_by_orderMovementId', domain: domainMovement, successMessage: 'Updated location order movement successfully',
  },
  receiverProductInStockFromInternal: {
    defaultValue: null, value: null, method: 'put', endpoint: 'receive_productInStock_from_internal_movement', domain: domainMovement, successMessage: 'Products added to location successfully',
  },
  receiverOrderFromInternal: {
    defaultValue: null, value: null, method: 'put', endpoint: 'receive_orders_from_internal_movement', domain: domainMovement, successMessage: 'Products added to location successfully',
  },
  receiveOrderFromOtherStore: {
    defaultValue: null, value: null, method: 'put', endpoint: 'receive_orderMovement_from_other_store', domain: domainMovement, successMessage: 'Updated order movement successfully',
  },
};

const mutations = Object.keys(state).reduce((acc, key) => {
  const mutationName = state[key].mutationName || `SET_${key.toUpperCase()}`;
  acc[mutationName] = (state, latest) => {
    state[key].value = latest;
  };
  state[key].mutation = mutationName;
  return acc;
}, {});

const getters = Object.keys(state).reduce((acc, key) => {
  const getterName = state[key].getterName || `get${key.charAt(0).toUpperCase() + key.slice(1)}`;
  acc[getterName] = (state) => { return state[key].value };
  return acc;
}, {});

const actions = {
  async makeRequest({ commit }, {
    domain, endpoint, method = 'get', params = {}, data = null, successMessage, mutation, requestId,
  }) {
    commit('SET_LOADING_STATE', { requestId, isLoading: true });
    try {
      const requestConfig = {
        method,
        url: `${domain}/${endpoint}`,
        ...(params && { params }),
        ...(data && { data }),
      };

      const response = await axiosInstance.request(requestConfig);
      const responseData = response.data?.items ? {
        items: response.data.items,
        totalItems: response.data.totalItems ?? 0,
        totalPages: response.data.totalPages ?? 1,
      } : response.data;

      if (mutation) commit(mutation, responseData);
      if (successMessage) showToast('success', successMessage);

      return responseData;
    } catch (error) {
      showToast('error', 'Something went wrong. Please try again.');
      commit('SET_LOADING_STATE', { requestId, isLoading: false });
      throw error;
    } finally {
      commit('SET_LOADING_STATE', { requestId, isLoading: false });
    }
  },
};

Object.keys(state).forEach((key) => {
  const actionName = state[key].nameOfMethod || `load${key.charAt(0).toUpperCase() + key.slice(1)}`;

  actions[actionName] = async ({ dispatch }, payload = {}) => {
    const {
      domain, method, mutation, endpoint, successMessage,
    } = state[key];

    const { successCallback, ...params } = payload;
    let data = null;

    if (payload.object || payload.list || payload.string || payload.number || payload.boolean || payload.obj) {
      data = payload.object || payload.list || payload.string || payload.number || payload.boolean || payload.obj;
      delete params?.object;
      delete params?.list;
      delete params?.string;
      delete params?.number;
      delete params?.boolean;
      delete params?.obj;
    }

    const hasParams = params && Object.keys(params).length > 0;
    const hasData = data != null && (
      (Array.isArray(data) && data.length > 0)
      || (typeof data === 'object' && Object.keys(data).length > 0)
      || (typeof data === 'string' && data.length > 0)
      || (typeof data === 'number' && !Number.isNaN(data))
      || (typeof data === 'boolean')
    );

    await dispatch('makeRequest', {
      domain,
      endpoint,
      method,
      ...(hasParams ? { params } : {}),
      ...(hasData ? { data } : {}),
      mutation,
      requestId: actionName,
      successMessage,
    });

    if (successCallback) {
      successCallback();
    }
  };

  const resetActionName = state[key].resetActionName || `reset${key.charAt(0).toUpperCase() + key.slice(1)}`;
  const mutationName = state[key].mutationName || state[key].mutation;
  actions[resetActionName] = ({ commit }) => {
    commit(mutationName, state[key].defaultValue);
  };
});



export default {
  state,
  getters,
  mutations,
  actions,
};
